import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href", "target"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["href", "target"]
const _hoisted_4 = { href: "signout" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("ul", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item, itemIdx) => {
      return (_openBlock(), _createElementBlock("li", {
        key: itemIdx,
        class: _normalizeClass({ 'disabled': $props.revalStatus === 'RequiresRevalidation' && item.stringId !== 'ml_104218', 'ap-menu-collapsed': item.childItems.length })
      }, [
        _createElementVNode("a", {
          href: item.link,
          target: item.target
        }, _toDisplayString(_ctx.$t(item.stringId)), 9, _hoisted_1),
        (item.childItems.length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.childItems, (childItem, childItemIdx) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: childItemIdx,
                  class: _normalizeClass({ 'disabled': $props.revalStatus === 'RequiresRevalidation' && childItem.stringId !== 'ml_104220' })
                }, [
                  _createElementVNode("a", {
                    href: childItem.link,
                    target: childItem.target
                  }, _toDisplayString(_ctx.$t(childItem.stringId)), 9, _hoisted_3)
                ], 2))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ], 2))
    }), 128)),
    _createElementVNode("li", null, [
      _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.$t('ml_104225')), 1)
    ])
  ]))
}